<template>
  <section v-loading="listLoading" class="page-container">
    <!--工具条-->
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.id" placeholder="ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.userId" placeholder="UserID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.orderNo" placeholder="OrderNO"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.sku" placeholder="SKU"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.size" placeholder="Size"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.statusArr" multiple placeholder="Status" clearable>
            <el-option v-for="s in statusList" :key="s.status" :value="s.status" :label="s.cn" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.payTag" placeholder="支付状态" clearable>
            <el-option :value="1" label="Bank Transfer (DP)" />
            <el-option :value="2" label="Bank Transfer (Full)" />
            <el-option :value="3" label="COD (DP)" />
            <el-option :value="4" label="COD (FULL)" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.deleted" placeholder="Deleted?" clearable>
            <el-option :value="false" label="NO" />
            <el-option :value="true" label="YES" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="filters.timeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            range-separator="-"
            start-placeholder="Begin time"
            end-placeholder="End time"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">Search</el-button>
          <el-button type="primary" @click="showExport">Export</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--列表-->
    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        height="100%"
        :data="results"
        highlight-current-row
        border
        stripe
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="orderNo" label="订单编号"></el-table-column>
        <el-table-column prop="size" label="尺码"></el-table-column>
        <el-table-column prop="productId" label="商品ID"></el-table-column>
        <el-table-column prop="productSku" label="款号"></el-table-column>
        <el-table-column prop="productName" label="商品名称"></el-table-column>
        <el-table-column prop="productImage" label="商品图片">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.productImage"
              :preview-src-list="[scope.row.productImage]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格"></el-table-column>
        <el-table-column prop="userId" label="用户编号"></el-table-column>
        <el-table-column prop="userId" label="用户昵称">
          <template slot-scope="scope">
            {{ scope.row.user ? scope.row.user.nickname || "" : "" }}
          </template>
        </el-table-column>
        <el-table-column prop="userId" label="用户头像">
          <template slot-scope="scope">
            <avatar v-if="scope.row.user" :user="scope.row.user" />
          </template>
        </el-table-column>
        <el-table-column prop="statusStr" label="状态">
          <template #default="{ row }">
            <div>{{ row.statusStr }}</div>
            <div style="color: red; margin-top: 3px">
              {{
                row.payTag === 1
                  ? "Bank Transfer (DP)"
                  : row.payTag === 2
                  ? "Bank Transfer (Full)"
                  : row.payTag === 3
                  ? "COD (DP)"
                  : row.payTag === 4
                  ? "COD (Full)"
                  : "-"
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间">
          <template slot-scope="scope">
            {{ scope.row.updateTime | formatDate }}
          </template>
        </el-table-column>

        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-dropdown type="primary" @command="handleCommand">
              <el-button type="primary" size="mini">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="{ type: 'detail', index: scope.$index, data: scope.row }"
                  >详情</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'paymentOrder', index: scope.$index, data: scope.row }"
                  >支付记录</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'showUpdateRecord', index: scope.$index, data: scope.row }"
                  >操作记录</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'updateStatus', index: scope.$index, data: scope.row }"
                  >修改状态</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'showImages', index: scope.$index, data: scope.row }"
                  >证书图片</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'showPayTag', index: scope.$index, data: scope.row }"
                  >支付状态</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <!-- 修改状态 -->
    <el-dialog title="修改状态" :visible.sync="updateStatusVisible" :close-on-click-modal="false">
      <el-form
        :key="updateStatusFormKey"
        ref="updateStatusForm"
        :model="updateStatusForm"
        label-width="80px"
      >
        <el-input v-model="updateStatusForm.id" type="hidden"></el-input>
        <el-form-item label="状态">
          <el-select v-model="updateStatusForm.status" placeholder="状态" clearable>
            <el-option v-for="s in statusList" :key="s.status" :value="s.status" :label="s.cn" />
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="updateStatusForm.memo" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item>
          <el-select v-model="updateStatusForm.statusOption" @change="updateStatusOptionsChange">
            <el-option
              v-for="(o, i) in updateStatusOptions"
              :key="i"
              :value="o.value"
              :label="o.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="图片">
          <image-upload v-model="updateStatusForm.image" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="updateStatusVisible = false">取消</el-button>
        <el-button type="primary" :loading="updateStatusLoading" @click.native="updateStatus"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--编辑界面-->
    <!-- <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-input v-model="editForm.id" type="hidden"></el-input>
        <el-form-item label="id">
          <el-input v-model="editForm.id"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog> -->

    <el-dialog
      title="订单详情"
      :visible.sync="orderDetailVisible"
      :close-on-click-modal="false"
      width="80%"
    >
      <el-descriptions v-if="orderDetail" title="基本信息" :column="3" border>
        <el-descriptions-item label="订单编号">{{ orderDetail.orderNo }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">{{ orderDetail.statusStr }}</el-descriptions-item>
        <el-descriptions-item label="商品ID">{{ orderDetail.productId }}</el-descriptions-item>
        <el-descriptions-item label="商品编码">{{ orderDetail.productSku }}</el-descriptions-item>
        <el-descriptions-item label="商品尺码">{{ orderDetail.size }}</el-descriptions-item>
        <el-descriptions-item label="子商品ID">{{
          orderDetail.productItemId
        }}</el-descriptions-item>
        <el-descriptions-item label="商品名称">{{ orderDetail.productName }}</el-descriptions-item>
        <el-descriptions-item label="卖家订单编号">{{
          orderDetail.sellerOrderNo
        }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{
          orderDetail.createTime | formatDate
        }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{
          orderDetail.updateTime | formatDate
        }}</el-descriptions-item>
      </el-descriptions>

      <el-descriptions
        v-if="orderDetail"
        title="用户/收货信息"
        :column="3"
        border
        style="margin-top: 20px"
      >
        <el-descriptions-item label="用户ID">{{ orderDetail.userId }}</el-descriptions-item>
        <el-descriptions-item label="用户昵称">{{
          orderDetail.user ? orderDetail.user.nickname || "" : ""
        }}</el-descriptions-item>
        <el-descriptions-item label="用户头像">
          <avatar v-if="orderDetail.user" :user="orderDetail.user" />
        </el-descriptions-item>
        <el-descriptions-item label="电话号码">{{ orderDetail.phone }}</el-descriptions-item>
        <el-descriptions-item label="First name">{{ orderDetail.firstName }}</el-descriptions-item>
        <el-descriptions-item label="Last name">{{ orderDetail.secondName }}</el-descriptions-item>
        <el-descriptions-item label="Province">{{ orderDetail.province }}</el-descriptions-item>
        <el-descriptions-item label="City">{{ orderDetail.city }}</el-descriptions-item>
        <el-descriptions-item label="Country">{{ orderDetail.country }}</el-descriptions-item>
        <el-descriptions-item label="Zip code">{{ orderDetail.zipCode }}</el-descriptions-item>
        <el-descriptions-item label="Address">{{ orderDetail.address }}</el-descriptions-item>
      </el-descriptions>

      <el-descriptions
        v-if="orderDetail"
        title="费用信息"
        :column="4"
        border
        style="margin-top: 20px"
      >
        <el-descriptions-item label="保证金">{{ orderDetail.deposit }}</el-descriptions-item>
        <el-descriptions-item label="保证金支付状态">{{
          orderDetail.depositPayed ? "已支付" : "未支付"
        }}</el-descriptions-item>
        <el-descriptions-item label="保证金支付时间">{{
          orderDetail.depositPayedTime | formatDate
        }}</el-descriptions-item>
        <el-descriptions-item label="保证金流水号">{{
          orderDetail.depositPayedReference
        }}</el-descriptions-item>

        <el-descriptions-item label="尾款">{{ orderDetail.balance }}</el-descriptions-item>
        <el-descriptions-item label="尾款支付状态">{{
          orderDetail.balancePayed ? "已支付" : "未支付"
        }}</el-descriptions-item>
        <el-descriptions-item label="尾款支付时间">{{
          orderDetail.balancePayedTime | formatDate
        }}</el-descriptions-item>
        <el-descriptions-item label="尾款金流水号">{{
          orderDetail.balancePayedReference
        }}</el-descriptions-item>

        <el-descriptions-item label="总费用">{{ orderDetail.totalFee }}</el-descriptions-item>
        <el-descriptions-item label="总已支付">{{
          orderDetail.totalFeePayed
        }}</el-descriptions-item>
        <el-descriptions-item label="总费用支付时间">{{
          orderDetail.totalFeePayedTime | formatDate
        }}</el-descriptions-item>
        <!-- <el-descriptions-item label="总费用流水号">{{
          orderDetail.totalFeePayedReference
        }}</el-descriptions-item> -->

        <el-descriptions-item label="运费">{{ orderDetail.expressFee }}</el-descriptions-item>
        <el-descriptions-item label="服务费">{{ orderDetail.rateFee }}</el-descriptions-item>
        <el-descriptions-item label="技术服务费">{{ orderDetail.techFee }}</el-descriptions-item>

        <el-descriptions-item label="用户优惠券ID">{{
          orderDetail.userCouponId
        }}</el-descriptions-item>
        <el-descriptions-item label="优惠金额">{{ orderDetail.discount }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>

    <order-update-record ref="updateRecord" :type="1" />
    <payment-order-dialog ref="paymentOrderDialog" />

    <el-dialog title="图片" :visible.sync="imagesVisible" :close-on-click-modal="false" width="90%">
      <div>
        <div style="padding: 20px; border-bottom: 1px solid #ccc">
          <img :src="certificateImageUrl" style="max-width: 100%" />
        </div>
        <div style="padding: 20px; border-bottom: 1px solid #ccc">
          <img :src="invoiceImageUrl" style="max-width: 100%" />
        </div>
        <div style="padding: 20px; border-bottom: 1px solid #ccc">
          <img :src="receiverInfoImageUrl" style="max-width: 100%" />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="imagesVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 支付状态 -->
    <el-dialog title="支付状态" :visible.sync="payTagVisible" :close-on-click-modal="false">
      <el-form :key="payTagFormKey" ref="payTagForm" :model="payTagForm" label-width="80px">
        <el-input v-model="payTagForm.id" type="hidden"></el-input>
        <el-form-item label="状态">
          <el-select v-model="payTagForm.payTag" placeholder="状态" clearable>
            <el-option :value="1" label="Bank Transfer (DP)" />
            <el-option :value="2" label="Bank Transfer (Full)" />
            <el-option :value="3" label="COD (DP)" />
            <el-option :value="4" label="COD (FULL)" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="payTagVisible = false">取消</el-button>
        <el-button type="primary" :loading="payTagLoading" @click.native="updatePayTag"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <order-export ref="orderExport" />
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import ImageUpload from "@/components/ImageUpload";
import Avatar from "@/components/Avatar";
import OrderUpdateRecord from "../order-update-record/index";
import PaymentOrderDialog from "../../payment-order/PaymentOrderDialog";
import OrderExport from "./OrderExport";
import mainHeight from "@/utils/mainHeight";
import { getToken } from "@/utils/auth";
import { mallApiUrl } from "@/filters";

export default {
  name: "BuyerOrder",
  components: {
    MyPagination,
    ImageUpload,
    Avatar,
    OrderUpdateRecord,
    PaymentOrderDialog,
    OrderExport,
  },
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      editForm: {},
      editFormVisible: false,
      editLoading: false,

      updateStatusFormKey: null,
      updateStatusForm: {},
      updateStatusVisible: false,
      updateStatusLoading: false,
      updateStatusOptions: [
        { name: "卖家未按时发货，退还买家金额", value: "We will refund All your payments" },
        { name: "卖家鞋子是假的，退还买家金额", value: "Because sellers sneakers judged" },
      ],

      payTagFormKey: null,
      payTagForm: {},
      payTagVisible: false,
      payTagLoading: false,

      orderDetailVisible: false,
      orderDetail: null,

      statusList: [],

      imagesVisible: false,
      certificateImageUrl: "",
      invoiceImageUrl: "",
      receiverInfoImageUrl: "",

      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    mainHeight(this);
    this.list();
    this.loadStatusList();
  },
  methods: {
    showExport() {
      this.$refs.orderExport.show();
    },
    async loadStatusList() {
      this.statusList = await this.axios.get("mall:/api/admin/buyer-order/statusList");
    },
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });

      if (this.filters.timeRange && this.filters.timeRange.length === 2) {
        params.dateFrom = this.filters.timeRange[0];
        params.dateTo = this.filters.timeRange[1];
      }

      if (this.filters.statusArr && this.filters.statusArr.length) {
        params.statusList = this.filters.statusArr.join(",");
      }

      try {
        this.results = [];
        const data = await this.axios.form("mall:/api/admin/buyer-order/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    handleCommand(cmd) {
      switch (cmd.type) {
        case "detail":
          // this.handleEdit(cmd.index, cmd.data);
          // this.$notify.success("暂未实现");
          this.showOrderDetail(cmd.index, cmd.data);
          break;
        case "paymentOrder":
          this.handlePaymentOrder(cmd.index, cmd.data);
          break;
        case "updateStatus":
          this.showUpdateStatus(cmd.index, cmd.data);
          break;
        case "showUpdateRecord":
          this.showUpdateRecord(cmd.index, cmd.data);
          break;
        case "showImages":
          this.showImages(cmd.index, cmd.data);
          break;
        case "showPayTag":
          this.showPayTag(cmd.index, cmd.data);
          break;
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("mall:/api/admin/buyer-order/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      this.editLoading = true;
      try {
        await this.axios.post("mall:/api/admin/buyer-order/update", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.editLoading = false;
      }
    },
    showUpdateStatus(index, row) {
      this.updateStatusFormKey = new Date().getTime();
      this.updateStatusVisible = true;
      this.updateStatusForm.id = row.id;
    },
    updateStatusOptionsChange(value) {
      this.updateStatusForm.memo = value;
    },
    async updateStatus() {
      try {
        await this.axios.form("mall:/api/admin/buyer-order/updateStatus", this.updateStatusForm);
        await this.list();
        this.updateStatusForm = {};
        this.updateStatusVisible = false;
        this.$notify.success("Success");
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async showOrderDetail(index, row) {
      try {
        this.orderDetail = await this.axios.get("mall:/api/admin/buyer-order/" + row.id);
        // await this.$refs.updateRecord.refresh(row.id);
        this.orderDetailVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async handlePaymentOrder(index, row) {
      this.$refs.paymentOrderDialog.show("BUYER_ORDER,BUYER_BALANCE_ORDER", row.id);
    },
    async showUpdateRecord(index, row) {
      await this.$refs.updateRecord.show(row.id);
    },
    async showImages(index, row) {
      this.certificateImageUrl = mallApiUrl(
        "/api/admin/buyer-order/certificateImage?orderId=" +
          row.id +
          "&userToken=" +
          getToken() +
          "&ts=" +
          new Date().getTime()
      );
      this.invoiceImageUrl = mallApiUrl(
        "/api/admin/buyer-order/invoiceImage?orderId=" +
          row.id +
          "&userToken=" +
          getToken() +
          "&ts=" +
          new Date().getTime()
      );
      this.receiverInfoImageUrl = mallApiUrl(
        "/api/admin/buyer-order/receiverInfoImage?orderId=" +
          row.id +
          "&userToken=" +
          getToken() +
          "&ts=" +
          new Date().getTime()
      );
      this.imagesVisible = true;
    },
    showPayTag(index, row) {
      this.payTagFormKey = new Date().getTime();
      this.payTagVisible = true;
      // this.payTagForm.id = row.id;
      // this.payTagForm.payTag = row.payTag;

      this.payTagForm = {
        id: row.id,
        payTag: row.payTag,
      };
    },
    async updatePayTag() {
      try {
        await this.axios.form("mall:/api/admin/buyer-order/updatePayTag", this.payTagForm);
        await this.list();
        this.payTagForm = {};
        this.payTagVisible = false;
        this.$notify.success("Success");
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
